// removed by extract-text-webpack-plugin
module.exports = {"component":"_13AJ1WJCTW1Qh5qp-ufbRR","qrcode":"_1kOhHJ-Kt8vaKqbVjG2O1R","img":"_3PPUaNSmMD7r0OW1iItWB2","qrcodetxt":"_1TYExWix1qANRE-qcGWVR5","tactTitle":"_2xHsYFHLbRTBgp04YaSNmv","tactLink":"_1lC4cazKwVlWS7Vz0M7MjO","tactCont":"_3oV3mUIdrLS0E1eFwCZ3FS","name":"_37VLcVYyLMS-IOo7sm9zAB","mt1":"_32b1bJYRLvw3yVXIbUg3Xe","mt2":"rhMydfmnIqWYmVM1-SW48","pa":"_2ecwkSkngXVHQX8y0UU42","tacOtherInfo":"uUZXJ5t05zofWqc7JLPwv","tactImg":"_JECpubZncCZX8FOjQRgY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CallUs/CallUs.scss
 ** module id = 1053
 ** module chunks = 0
 **/